import { z } from 'zod';
import { coerceUrl } from './url.js';
export const zNonEmptyString = (message) => z.string().trim().min(1, { message });
export const zCoerceInt = z.coerce.number().int();
export const zJson = (schema, message = 'Invalid JSON') => z
    .string()
    .transform((str, ctx) => {
    try {
        return JSON.parse(str);
    }
    catch {
        ctx.addIssue({
            code: 'custom',
            message,
        });
        return z.NEVER;
    }
})
    .pipe(schema);
export const zUrl = (errors) => zNonEmptyString(errors.nonEmpty)
    .transform((str) => coerceUrl(str))
    .pipe(z.instanceof(URL, { error: errors.url }));
//# sourceMappingURL=zod.js.map